export default timeStr => {
  if (!String(timeStr).includes(':')) return timeStr
  const time = timeStr.split(':')
  return parseInt(time[0]) * 60 + parseInt(time[1])
}
